/** A provider that passes through to a synchronous source. */
export class ThroughProvider {
    source;
    constructor(source) {
        this.source = source;
    }
    getItem(collection, id) {
        return this.source.getItem(collection, id);
    }
    requireItem(collection, id) {
        return this.source.requireItem(collection, id);
    }
    getItemSequence(collection, id) {
        return this.source.getItemSequence(collection, id);
    }
    addItem(collection, data) {
        return this.source.addItem(collection, data);
    }
    setItem(collection, id, data) {
        return this.source.setItem(collection, id, data);
    }
    updateItem(collection, id, update) {
        return this.source.updateItem(collection, id, update);
    }
    deleteItem(collection, id) {
        return this.source.deleteItem(collection, id);
    }
    countQuery(collection, query) {
        return this.source.countQuery(collection, query);
    }
    getQuery(collection, query) {
        return this.source.getQuery(collection, query);
    }
    getQuerySequence(collection, query) {
        return this.source.getQuerySequence(collection, query);
    }
    setQuery(collection, query, data) {
        return this.source.setQuery(collection, query, data);
    }
    updateQuery(collection, query, update) {
        return this.source.updateQuery(collection, query, update);
    }
    deleteQuery(collection, query) {
        return this.source.deleteQuery(collection, query);
    }
    getFirst(collection, query) {
        return this.source.getFirst(collection, query);
    }
    requireFirst(collection, query) {
        return this.source.requireFirst(collection, query);
    }
}
/** A provider that passes through to an asynchronous source. */
export class AsyncThroughProvider {
    source;
    constructor(source) {
        this.source = source;
    }
    getItem(collection, id) {
        return this.source.getItem(collection, id);
    }
    requireItem(collection, id) {
        return this.source.requireItem(collection, id);
    }
    getItemSequence(collection, id) {
        return this.source.getItemSequence(collection, id);
    }
    addItem(collection, data) {
        return this.source.addItem(collection, data);
    }
    setItem(collection, id, data) {
        return this.source.setItem(collection, id, data);
    }
    updateItem(collection, id, updates) {
        return this.source.updateItem(collection, id, updates);
    }
    deleteItem(collection, id) {
        return this.source.deleteItem(collection, id);
    }
    countQuery(collection, query) {
        return this.source.countQuery(collection, query);
    }
    getQuery(collection, query) {
        return this.source.getQuery(collection, query);
    }
    getQuerySequence(collection, query) {
        return this.source.getQuerySequence(collection, query);
    }
    setQuery(collection, query, data) {
        return this.source.setQuery(collection, query, data);
    }
    updateQuery(collection, query, updates) {
        return this.source.updateQuery(collection, query, updates);
    }
    deleteQuery(collection, query) {
        return this.source.deleteQuery(collection, query);
    }
    getFirst(collection, query) {
        return this.source.getFirst(collection, query);
    }
    requireFirst(collection, query) {
        return this.source.requireFirst(collection, query);
    }
}
